<template>
    <span>
        <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col sm="9">
                    <h3>Editar Município</h3>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuario.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
          <b-form v-on:submit.prevent="onSubmit">
            <b-row v-if="!block">
              <b-col sm="6">
                <b-form-group label="UF: *">
                  <b-form-select :disabled="block" :state="chkState('uf_id')" v-model="$v.form.uf_id.$model" :options="estados" class="mb-3">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback1">UF é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group label="Município: *" :disabled="disabled_cidades || block">
                  <b-form-select
                    v-model="$v.form.municipio_id.$model"
                    :state="chkState('municipio_id')"
                    :options="cidades">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="input1LiveFeedback2">Município é obrigatório.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <b-form-group label="DDD + Telefone: *">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                      v-mask="'+55 (##) #####-####'"
                      class="form-control"
                      placeholder="Telefone"
                      :disabled="visualizar"
                      autocomplete="telefone"
                      v-model.lazy.trim="$v.form.telefone.$model"
                      :state="chkState('telefone')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Telefone é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="8">
                  <label>Bandeira ou imagem do município: *</label>
                    <span class="icon-info" v-b-popover.hover.top="'Permitidos apenas imagens e arquivos .pdf'" title="Informação"></span>
                  <b-form-group label-for="nome-input" invalid-feedback="Imagem é obrigatório">
                    <b-form-file browse-text="Selecione" placeholder="Selecione o documento" v-on:change="uploadDoc" :state="chkState('imagem')"></b-form-file>
                    <b-form-invalid-feedback id="input1LiveFeedback4">Imagem é obrigatório.</b-form-invalid-feedback>
                  </b-form-group>
              </b-col>
              <b-col v-if="imagemAtual" cols="12">
                 <label>Bandeira atual:</label>
                 <div class="image-preview">
                      <img class="preview" :src="imagemAtual">
                       <br><br>
                 </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Endereço para atendimento: *">
                    <b-input-group class="mb-6">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Endereço para atendimento"
                                  v-model="$v.form.endereco.$model"
                                  :state="chkState('endereco')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback5">Endereço é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Nome do Responsável: *">
                    <b-input-group class="mb-6">
                      <b-input-group-prepend>
                        <b-input-group-text><i class="icon-user"></i></b-input-group-text>
                      </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do Responsável"
                                  v-model="$v.form.nome_responsavel.$model"
                                  :state="chkState('nome_responsavel')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback6">Nome do Responsável é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Site do município: *">
                  <b-input-group class="mb-6">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-link"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Site do município "
                                  v-model="$v.form.link.$model"
                                  :state="chkState('link')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Site do município é obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="!block">
              <b-col cols="3">
                <b-form-group label="Ativo? *">
                  <b-input-group class="mb-6">
                    <b-form-select  v-model="$v.form.ativo.$model" :state="chkState('ativo')" class="mb-3">
                      <option selected :value="true"> Sim</option>
                      <option :value="false"> Não</option>
                    </b-form-select>
                    <b-form-invalid-feedback id="input1LiveFeedback8">Ativação é obrigatória.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card-body>
         <b-card-footer class="p-12">
          <b-row>
            <b-col md="3" offset-md="3">
              <b-button block variant="primary" v-on:click="onSubmit">
                <i class="fa fa-check"></i>&nbsp;
                <span>Salvar Município</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" @click="$router.go(-1)">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
    </b-card>
    </span>
</template>

<script>
import 'v-markdown-editor/dist/v-markdown-editor.css'
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, requiredIf} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

const formShape = {
  endereco: '',
  nome_responsavel: '',
  link: '',
  imagem: '',
  telefone: null,
  municipio_id: null,
  uf_id: null,
  ativo: true
}

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      telefone: {
        required
      },
      nome_responsavel: {
        required
      },
      link: {
        required
      },
      endereco: {
        required
      },
      municipio_id: {
        required
      },
      uf_id: {
        required
      },
      ativo: {
        required
      },
      imagem: {
        required: requiredIf(function (nestedModel) {
          return !this.imagemAtual
        })
      }
    }
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'P' || SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') === 'L') {
      this.$store.dispatch('buscarEstados')
      this.loadMunicipio(parseInt(SessionStorage.get('usuario')))
    } else {
      this.$router.push('/')
    }

    this.$store.dispatch('buscarMunicipiosProgramas')
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
  },
  data () {
    return {
      form: Object.assign({}, formShape),
      id: 0,
      imagemAtual: false,
      descricaoValid: null,
      disabled_cidades: true,
      block: true,
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: ''
      }
    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    municipiosprogramas () {
      return this.$store.state.municipiosprogramas.listaMunicipiosProgramas
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  watch: {
    '$v.form.uf_id.$model': function () {
      if (this.form.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.form.uf_id)
        this.disabled_cidades = false
      } else {
        this.disabled_cidades = true
        this.form.municipio_id = null
      }
    },
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    },
    'usuario.dados_pessoais': function () {
      this.municipiosprogramas.forEach(element => {
        if (element.municipio_id === this.usuario.dados_pessoais.municipio_atuacao_id) {
          this.usuarioLogado.estado = element.estado.estado
          this.usuarioLogado.municipio = element.cidade.cidade
        }
      })
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    salvar () {
      var form = this.$v.form

      let data = {
        id: this.id,
        imagem_bandeira: form.imagem.$model,
        link: form.link.$model,
        nome_responsavel: form.nome_responsavel.$model,
        endereco: form.endereco.$model,
        telefone: form.telefone.$model.replace(/[^\d]+/g, ''),
        municipio_id: form.municipio_id.$model,
        uf_id: form.uf_id.$model,
        ativo: form.ativo.$model
      }

      Vue.http.post('api/municipios', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          if (this.cadastroInterno) {
            miniToastr.success('Município salvo com sucesso!', 'Sucesso!', 7000)
          } else {
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          }

          this.$router.push({path: '/municipios-gestor'})
        } else {
          this.disable_buttons = false
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    loadMunicipio (id) {
      Vue.http.get('api/municipios/' + id).then(response => {
        this.form.telefone = response.body.data.telefone
        this.form.link = response.body.data.link
        this.form.nome_responsavel = response.body.data.nome_responsavel
        this.form.endereco = response.body.data.endereco
        this.form.municipio_id = response.body.data.municipio_id
        this.form.uf_id = response.body.data.uf_id
        this.form.ativo = response.body.data.ativo
        this.imagemAtual = response.body.data.imagem_bandeira
        this.id = response.body.data.id
      })
    },
    uploadDoc (evento) {
      let arquivo = evento.target.files || evento.dataTransfer.files
      const mimetypes = ['image/bmp', 'image/jpeg', 'image/png']
      if (!arquivo.length) {
        return false
      }

      if (!mimetypes.includes(arquivo[0].type)) {
        this.erro('Anexo inválido!')
        arquivo = null
        return null
      }

      if (arquivo[0].size > 6000000) {
        this.erro('Permitido somente anexos de até 6 MB!')
        arquivo = null
        return null
      }
      let reader = new FileReader()

      reader.onload = (evento) => {
        this.$v.form.imagem.$model = evento.target.result
      }
      reader.readAsDataURL(arquivo[0])
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      console.log(this.$v.form)
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())

      if (this.$v.form.endereco.$model && this.$v.form.endereco.$model.length >= 200) {
        this.erro('Limite do endereço é de 200 caracteres.')
        return false
      }

      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    },
    erro (msg) {
      miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
      miniToastr.error(msg, 'Alerta!', 5000)
    }
  }
}
</script>

<style scoped>
    img.preview {
        width: 200px;
        background-color: white;
        border: 1px solid #DDD;
        padding: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/municipios/MunicipioFormGestor.vue